/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'aboutus': {
    width: 21,
    height: 21,
    viewBox: '0 0 21 21',
    data: '<path pid="0" d="M19.766 10.609a8.971 8.971 0 1 0-17.943 0 8.971 8.971 0 0 0 17.943 0zm1 0c0 5.507-4.464 9.971-9.971 9.971S.823 16.116.823 10.61 5.288.637 10.795.637s9.97 4.465 9.97 9.972zm-9.471 4.84V8.758h-1v6.693h1zm0-7.77v-1.5h-1v1.5h1z" _fill="#848484" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/aboutus.js